import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row'
  },
  row2: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: 'navy',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const RetailSalePosPDF = ({ data }) => {
  console.log(data);
  function formatDateToMonthYear(dateString) {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  }

  const grandTotal = parseFloat((data?.bill_amount + data?.cgst + data?.sgst).toFixed(2));

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Retail Sale Pos`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="Retail Sale" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row2}>
                <Text content="Invoice No.      :" style={styles.textBold} />
                <Text content={`${data.inv_no}`} />
              </View>
              <View style={styles.row2}>
                <Text content="UHID NO.        :" style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Date/Time       :" />
                <Text content={`${dateFormatter(data.dateTime)}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Address          :" />
                <Text content={`${data.address}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row2}>
                <Text content="Patient Name      : " />
                <Text content={`${data.patientName}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Age/Sex              :" />
                <Text content={`${data.age} / ${data.gender}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Mobile                 :" />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row2}>
                <Text content="Department            :" />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Sponsor                  :" />
                <Text content={`${data.sponsor}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Operating Doctor    : " />
                <Text content={`${data.doctor}`} />
              </View>
            </View>
          </View>

          {/* Table */}
          <View style={styles.row}>
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr." />
            <Text style={{ ...styles.columnHeader, width: '30%', textAlign: 'start' }} content="Particulars" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Pack" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="HSN" />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Batch" />
            <Text style={{ ...styles.columnHeader, width: '30%' }} content="Exp." />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Qty" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Mrp" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Amount" />
          </View>
          {data.productDetails &&
            data?.productDetails?.map((service, index) => (
              <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                <Text style={{ ...styles.columnContent, width: '10%' }} content={index + 1} />
                <Text
                  style={{ ...styles.columnContent, width: '30%', textAlign: 'start' }}
                  content={service.product_name}
                />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={service.packing} />
                <Text style={{ ...styles.columnContent, width: '15%' }} content={service.hsn_code} />
                <Text style={{ ...styles.columnContent, width: '20%' }} content={service.batch_no} />
                <Text
                  style={{ ...styles.columnContent, width: '30%' }}
                  content={formatDateToMonthYear(service.exp_date)}
                />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={service.bill_qty} />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={service.mrp} />
                <Text style={{ ...styles.columnContent, width: '10%' }} content={service?.amount} />
              </View>
            ))}

          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={{ marginTop: '35px' }}>
                <Text content="Print Date /Time        :" />
                <Text content={`${dateFormatter()}`} />
              </View>
            </View>
            <View style={{ ...styles.column, marginLeft: '60%' }}>
              <View style={styles.row2}>
                <Text content="Sub Total       :  " />
                <Text content={`${data.total_amt}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Discount        :  " />
                <Text content={`${data.dis_amount}`} />
              </View>
              <View style={styles.row2}>
                <Text content="Bill Amount   :  " />
                <Text content={`${data.bill_amount}`} />
              </View>
              <View
                style={{
                  ...styles.row
                }}
              >
                {data.pay_mode === 'CASH' || data.pay_mode === 'Bank' ? (
                  <Text content="Recd  " />
                ) : (
                  <Text content="Balance  " />
                )}

                {/* Check if pay_mode is 'CASH', 'Credit', or 'Bank' */}
                {data.pay_mode === 'CASH' ? (
                  <>
                    <Text content="Cash   :  " />
                    <Text content={`${data.total_amt}`} />
                  </>
                ) : data.pay_mode === 'Bank' ? (
                  <>
                    <Text content="      Bank      :" />
                    <Text content={`${data.total_amt}`} />
                  </>
                ) : (
                  ['Credit'].includes(data.pay_mode) && (
                    <>
                      <Text content="      Pending     :" />
                      <Text content={`${data.total_amt}`} />
                    </>
                  )
                )}
              </View>
              <View style={styles.row2}>
                <Text content="Balance         :  " />
                <Text content={`${data.balance_amt}`} />
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
